module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "close-window",
    on: {
      "click": _vm.close
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close-round"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "code"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Button', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.codeBtn
    }
  }, [_vm._v(_vm._s(_vm.codeText))])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "passwdCheck"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "再次确认密码"
    },
    model: {
      value: (_vm.form.passwdCheck),
      callback: function($$v) {
        _vm.$set(_vm.form, "passwdCheck", $$v)
      },
      expression: "form.passwdCheck"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        return _vm.getPassword('form')
      }
    }
  }, [_vm._v("找回密码")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("已有账号？登录")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "long": ""
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("还没有账号？立即注册")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("忘记密码")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-428638d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/forgot.vue
// module id = 488
// module chunks = 15